/** Keep Home product covers out of the poster's initial network queue. */
(() => {
  let released = false;
  const controller = new AbortController();
  const options = { signal: controller.signal, capture: true, passive: true };
  const release = () => {
    if (released) return;
    released = true;
    clearTimeout(fallback);
    controller.abort();
    document.querySelectorAll('template[data-vs-home-image]').forEach((template) => {
      template.replaceWith(template.content.cloneNode(true));
    });
  };
  // Restore native lazy images before a user's scroll can expose the next section.
  const onKey = (event) => {
    if (['ArrowDown', 'PageDown', 'End', ' '].includes(event.key)) release();
  };
  document.addEventListener('vs:hero-buffer-ready', release, options);
  document.addEventListener('vs:hero-poster-ready', () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) release();
  }, options);
  document.addEventListener('wheel', release, options);
  document.addEventListener('touchmove', release, options);
  document.addEventListener('keydown', onKey, options);
  document.addEventListener('scroll', release, options);
  document.querySelector('[data-vs-hero-scroll]')?.addEventListener('pointerdown', release, options);
  const fallback = setTimeout(release, 30000);
  const hero = document.querySelector('vs-hero-motion');
  if (!hero || hero.hasAttribute('data-buffer-ready') || (hero.hasAttribute('data-poster-ready') && window.matchMedia('(prefers-reduced-motion: reduce)').matches) || hero.getBoundingClientRect().bottom <= 0) release();
})();
